<template>
  <div class='page-content'>
    <transition name="fade-transform" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
    export default {
        name: 'step'
    }
</script>


// WEBPACK FOOTER //
// src/components/Step.vue